"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var themeContext_1 = require("../../utils/themeContext");
var Loader_1 = __importDefault(require("../Loader"));
var Field = function (_a) {
    var children = _a.children, title = _a.title, hint = _a.hint, error = _a.error, fieldTitleUpper = _a.theme.fieldTitleUpper, className = _a.className, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.loadingProps, loadingProps = _c === void 0 ? {} : _c;
    var loadingClassName = loadingProps.className, restLoadingProps = __rest(loadingProps, ["className"]);
    return (react_1.default.createElement("div", { className: classnames_1.default('aui-Field', { 'aui-Field-has-hint': hint }, { 'aui-Field-has-error': error }, className) },
        title && (react_1.default.createElement("div", { className: classnames_1.default('aui-Field-title', {
                'aui-Field-title-upper': fieldTitleUpper,
            }) }, title)),
        react_1.default.createElement("div", { className: "aui-Field-field" },
            children,
            loading && (react_1.default.createElement(Loader_1.default, __assign({ size: 3, className: classnames_1.default('aui-Field-loader', loadingClassName) }, restLoadingProps)))),
        hint && react_1.default.createElement("div", { className: "aui-Field-hint" }, hint),
        error && react_1.default.createElement("div", { className: "aui-Field-error" }, error)));
};
exports.default = themeContext_1.withTheme(Field);
